const getConfigForPath = (applications, path) => {
  const apps = applications?.modules || { '/': { modules: { } } };
  const currentAppName = Object.keys(apps).find(a =>
    (path || '/').startsWith(a)
  );
  const currentApp = apps[currentAppName];

  const config = {};
  for (const [name, module] of Object.entries(currentApp.modules || {})) {
    config[name] = module;
  }
  for (const [name, app] of Object.entries(apps)) {
    if (name !== currentAppName) {
      config[name] = app.url;
    }
  }

  return {
    modules: config,
    redirects: applications?.redirects || {}
  };
};

export { getConfigForPath };
